import React, {useState, useEffect} from 'react';
import {Button, Breadcrumb, Card, Row, Col, Input, Select, message, Form, Popconfirm} from 'antd';
import {Link, useNavigate, useParams} from "react-router-dom";
import {DeleteOutlined, SaveOutlined} from "@ant-design/icons";
import TableTransfer from "./TableTransfer";
import {useSelector} from "react-redux";
import {useGetVehicleQuery} from "../../../slices/rootApiSlices/vehicleApiSlice";
import {
    useGetGroupByIdQuery,
    useUpdateGroupByIdMutation,
    useUpdateVehicleGroupByIdMutation,
    useDeleteGroupByIdMutation, useGetGroupsQuery
} from "../../../slices/rootApiSlices/groupApiSlice";

const {Option} = Select;

const Update = () => {

    const [form] = Form.useForm();
    const {id} = useParams();
    const navigate = useNavigate();
    const {user} = useSelector(state => state.auth);
    const {data: vehiclesData, isLoading} = useGetVehicleQuery(user?.token);
    const {refetch} = useGetGroupsQuery(user?.token);
    const {data: groupDetailData, isLoading: isGroupLoading} = useGetGroupByIdQuery({token: user?.token, id: id});
    const [handleUpdate, {loading: updateVehicleLoading}] = useUpdateVehicleGroupByIdMutation();
    const [handleDelete] = useDeleteGroupByIdMutation();
    const [groupUpdate, {isLoading: updateLoading}] = useUpdateGroupByIdMutation();
    const vehicles = vehiclesData?.data || [];
    const groupVehicles = groupDetailData?.group?.vehicles || [];

    const [targetKeys, setTargetKeys] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [isActive, setIsActive] = useState(false);

    const deleteHandle = async () => {
        try {
            await handleDelete({token: user?.token, id: id}).unwrap();
            refetch();
            navigate('/settings/groups');
            message.success('Grup silme işlemi başarılı.');
        } catch (e) {
            message.error('Grup silme işlemi sırasında hata oluştu.');

        }
    }

    const updateHandle = async () => {
        try {
            await handleUpdate({
                token: user?.token,
                vehicleIds: targetKeys,
                id: id
            }).unwrap();
            message.success('Araç atama işlemi başarılı.');
        } catch (e) {
            message.error('Araç atama işlemi sırasında hata oluştu.');
        }
    };

    const updateGroup = async () => {
        const groupData = {
            title: form.getFieldValue("title"),
            description: form.getFieldValue("description"),
            isActive: form.getFieldValue("isActive"),
        };
        try {
            groupUpdate({
                token: user?.token,
                data: groupData,
                id: id
            }).unwrap();
            message.success('Grup güncelleme işlemi başarılı')
        } catch (e) {
            message.error('Güncelleme sırasında hata oluştu.')
        }
    }

    useEffect(() => {
        if (groupDetailData?.group) {
            form.setFieldsValue({
                title: groupDetailData?.group?.title,
                description: groupDetailData?.group?.description,
                isActive: groupDetailData?.group?.isActive,
            });
        }
    }, [groupDetailData, form]);

    useEffect(() => {
        if (groupVehicles.length > 0) {
            const initialTargetKeys = groupVehicles.map(vehicle => vehicle.id);
            setTargetKeys(initialTargetKeys);
        }
        if (groupDetailData?.group) {
            setTitle(groupDetailData.group.title || '');
            setDescription(groupDetailData.group.description || '');
            setIsActive(groupDetailData.group.isActive || false);
        }
    }, [groupVehicles, groupDetailData]);

    const handleChange = (nextTargetKeys) => {
        setTargetKeys(nextTargetKeys);
    };

    const handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
        setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
    };

    const columns = [
        {
            title: 'Plaka',
            dataIndex: 'plateNumber',
        },
        {
            title: 'Cihaz ID',
            dataIndex: 'device_id',
        },
        {
            title: 'Şasi No',
            dataIndex: 'chassisNumber',
        },
    ];

    return (
        <div>
            <Breadcrumb style={{marginBottom: 16}}>
                <Breadcrumb.Item>
                    <Link to="/">Ana Ekran</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <Link to="/settings/groups">Grup Listesi</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>Grup Detay</Breadcrumb.Item>
            </Breadcrumb>
            <Row justify="center" align="middle" style={{height: '100%'}}>
                <Col span={24}>
                    <Card
                        type="inner"
                        title="Grup Bilgileri"
                        size="small"
                        extra={
                            <Popconfirm
                                title="Delete the task"
                                placement="leftTop"
                                description="Araç grubunu silmek istediğine emin misin ?"
                                onConfirm={deleteHandle}
                                okText="Sil"
                                cancelText="İptal"
                            >
                                <Button
                                    type="primary" danger size="small" icon={<DeleteOutlined/>}>
                                    Sil
                                </Button>
                            </Popconfirm>
                        }
                        style={{marginBottom: 16}}
                    >
                        <Form
                            form={form}
                            name="update-group"
                            layout="vertical"
                        >
                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item
                                        label="Adı"
                                        name="title"
                                        onChange={e => setTitle(e.target.value)}
                                        value={title}
                                        rules={[{required: true, message: 'Lütfen grup adı giriniz'}]}
                                    >
                                        <Input placeholder="Grup Adı"/>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Açıklama"
                                        name="description"
                                        onChange={e => setDescription(e.target.value)}
                                        value={description}
                                        rules={[{required: true, message: 'Lütfen açıklama giriniz'}]}
                                    >
                                        <Input placeholder="Açıklama"/>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label="Durum"
                                        name="isActive"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'lütfen durum giriniz !',
                                            },
                                        ]}
                                        value={isActive}
                                    >
                                        <Select
                                            onChange={(e) => setIsActive({...isActive})}
                                            placeholder="Durum seçiniz.."
                                            allowClear
                                        >
                                            <Option value={true}>Aktif</Option>
                                            <Option value={false}>Pasif</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                        <Button
                            icon={<SaveOutlined/>}
                            type="primary"
                            onClick={updateGroup}
                            style={{marginTop: 16, float: 'right'}}
                            loading={updateLoading}
                            disabled={updateLoading || isLoading || isGroupLoading || updateVehicleLoading}
                        >
                            Güncelle
                        </Button>
                    </Card>
                    <Card
                        type="inner"
                        title={title}
                        size="small"
                    >
                        <TableTransfer
                            rowKey={item => item.id || item.device_id || item.key}
                            dataSource={vehicles}
                            titles={['Müsait Araçlar', 'Gruba Atanmış Araçlar']}
                            targetKeys={targetKeys}
                            selectedKeys={selectedKeys}
                            onChange={handleChange}
                            onSelectChange={handleSelectChange}
                            leftColumns={columns}
                            rightColumns={columns}
                            loading={isLoading || isGroupLoading}
                        />
                        <Button
                            icon={<SaveOutlined/>}
                            type="primary"
                            onClick={updateHandle}
                            style={{marginTop: 16, float: 'right'}}
                            loading={updateLoading}
                            disabled={updateLoading || isLoading || isGroupLoading || updateVehicleLoading}
                        >
                            Araç ata
                        </Button>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Update;
